{
  "title": "Maze",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level conjuration",
  "level": 8,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You banish a creature that you can see within range into a labyrinthine demiplane. The target remains there for the duration or until it escapes the maze.",
    "The target can use its action to attempt to escape. When it does so, it makes a DC 20 Intelligence check. If it succeeds, it escapes, and the spell ends (a minotaur or goristro demon automatically succeeds).",
    "When the spell ends, the target reappears in the space it left or, if that space is occupied, in the nearest unoccupied space."
  ],
  "spellLists": ["wizard"]
}
